import { useEffect, Suspense } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LaytonHero from './components/LaytonHero';
import LaytonTrust from './components/LaytonTrust';
import LaytonServices from './components/LaytonServices';
import LaytonNeighborhoods from './components/LaytonNeighborhoods';
import LaytonTestimonial from './components/LaytonTestimonial';
import LaytonContact from './components/LaytonContact';

export default function LaytonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Water Damage Restoration Layton Utah | 24/7 Emergency Cleanup | Davis County Disaster Cleanup';
    
    const metaTags = [
      { name: 'description', content: 'Expert water damage restoration in Layton, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair. Fast response for Layton homes and businesses. Call (385) 340-6632 now!' },
      { name: 'keywords', content: 'water damage restoration Layton, flood cleanup Layton Utah, mold remediation Layton, fire damage repair Layton, emergency restoration Layton' },
      { name: 'geo.region', content: 'US-UT' },
      { name: 'geo.placename', content: 'Layton, Utah' },
      { name: 'geo.position', content: '41.0602;-111.9711' },
      { name: 'ICBM', content: '41.0602, -111.9711' },
      { property: 'og:title', content: 'Water Damage Restoration Layton Utah | 24/7 Emergency Cleanup' },
      { property: 'og:description', content: 'Expert water damage restoration in Layton, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair. Fast response for Layton homes and businesses.' },
      { property: 'og:url', content: 'https://daviscountydisastercleanup.com/layton' },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Water Damage Restoration Layton Utah | 24/7 Emergency Cleanup' },
      { name: 'twitter:description', content: 'Expert water damage restoration in Layton, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair.' }
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value as string);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content as string);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/layton');

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide 24/7 emergency services in Layton?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes! Davis County Disaster Cleanup provides 24/7 emergency disaster restoration services throughout Layton, Utah. We respond immediately to water damage, flooding, fire damage, and other emergencies in all Layton neighborhoods including East Layton, North Layton, and areas near Layton Hills Mall."
          }
        },
        {
          "@type": "Question",
          "name": "What areas of Layton do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve all of Layton, Utah including East Layton, North Layton, Cherry Lane area, Layton Commons, West Layton, Adams Avenue corridor, and surrounding Davis County communities. Our team provides fast response throughout the entire Layton area."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can you respond to a water damage emergency in Layton?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We typically arrive at Layton properties within 60-90 minutes of your call. Our rapid response team is strategically located to serve Layton and surrounding areas quickly, minimizing water damage and beginning the restoration process immediately."
          }
        }
      ]
    };

    let script = document.querySelector('script[data-schema="layton-faq"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-schema', 'layton-faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="layton-faq"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <LaytonHero />
        <LaytonTrust />
        <LaytonServices />
        <LaytonNeighborhoods />
        <LaytonTestimonial />
        <LaytonContact />
        <Footer />
      </div>
    </Suspense>
  );
}
